(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-multicolumn"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    root.querySelectorAll('[data-tab-multicolumn]').forEach(function (wrap) {
      var content = wrap.querySelector('[data-tab-multicolumn-content]');
      var tabsHost = wrap.querySelector('[data-tab-multicolumn-tabs-host]');
      /* The ready flag alone is not enough: theme editor / theme dev hot
         reloads can morph the HTML (wiping the JS-built tabs) while the
         flag survives on the wrapper. Re-init whenever the tabs are gone. */
      if (wrap.dataset.tabMulticolumnReady === 'true' && tabsHost && tabsHost.children.length > 0) return;
      wrap.dataset.tabMulticolumnReady = 'true';

      var contentPrev = wrap.querySelector('[data-tab-multicolumn-content-prev]');
      var contentNext = wrap.querySelector('[data-tab-multicolumn-content-next]');
      var contentNavigation = wrap.querySelector('[data-tab-multicolumn-content-navigation]');
      var isCarousel = wrap.classList.contains('tab-multicolumn--carousel');
      if (!content || !tabsHost) return;

      function norm(value) {
        return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
      }

      var tabSources = content.querySelectorAll('[data-tab-multicolumn-tab-name]');
      if (tabSources.length === 0) return;

      var tabKeys = [];
      var tabLabelByKey = {};
      tabSources.forEach(function (src) {
        var raw = src.getAttribute('data-tab-multicolumn-tab-name');
        var key = norm(raw);
        if (!key) return;
        if (tabKeys.indexOf(key) === -1) {
          tabKeys.push(key);
          tabLabelByKey[key] = (raw || '').trim();
        }
      });

      if (tabKeys.length === 0) return;

      tabsHost.innerHTML = '';
      tabKeys.forEach(function (key, idx) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tab-multicolumn__tab' + (idx === 0 ? ' is-active' : '');
        btn.setAttribute('data-tab-target', key);
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
        var label = document.createElement('span');
        label.className = 'tab-multicolumn__tab-label';
        label.textContent = tabLabelByKey[key];
        btn.appendChild(label);
        btn.addEventListener('click', function () { activate(key); });
        tabsHost.appendChild(btn);
      });

      var cols = content.querySelectorAll('[data-tab-name]');
      var activeColumns = [];
      var activeColumnIndex = 0;

      function eagerLoadImages(columns) {
        columns.forEach(function (col) {
          col.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
            img.setAttribute('loading', 'eager');
          });
        });
      }

      function activate(key) {
        tabsHost.querySelectorAll('.tab-multicolumn__tab').forEach(function (t) {
          var match = t.getAttribute('data-tab-target') === key;
          t.classList.toggle('is-active', match);
          t.setAttribute('aria-selected', match ? 'true' : 'false');
        });
        cols.forEach(function (col) {
          var match = norm(col.getAttribute('data-tab-name')) === key;
          col.setAttribute('data-tab-hidden', match ? 'false' : 'true');
        });
        activeColumns = Array.prototype.filter.call(cols, function (col) {
          return col.getAttribute('data-tab-hidden') === 'false';
        });
        activeColumnIndex = 0;
        eagerLoadImages(activeColumns);
        if (isCarousel) {
          cols.forEach(function (col) {
            col.setAttribute('data-tab-column-hidden', 'false');
          });
          content.scrollTo({ left: 0 });
          updateCarouselControls();
        } else {
          showActiveColumn();
        }
      }

      function showActiveColumn() {
        activeColumns.forEach(function (col, index) {
          col.setAttribute('data-tab-column-hidden', index === activeColumnIndex ? 'false' : 'true');
        });
        updateContentControl();
      }

      function updateContentControl() {
        var hasPrevColumn = activeColumnIndex > 0;
        var hasNextColumn = activeColumnIndex < activeColumns.length - 1;
        if (contentPrev) contentPrev.hidden = !hasPrevColumn;
        if (contentNext) contentNext.hidden = !hasNextColumn;
        if (contentNavigation) contentNavigation.hidden = !hasPrevColumn && !hasNextColumn;
      }

      function slideStep() {
        var first = activeColumns[0];
        if (!first) return content.clientWidth;
        var gap = parseFloat(window.getComputedStyle(content).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      function updateCarouselControls() {
        var maxScroll = content.scrollWidth - content.clientWidth;
        if (contentNavigation) contentNavigation.hidden = maxScroll <= 4;
        if (contentPrev) contentPrev.hidden = content.scrollLeft <= 4;
        if (contentNext) contentNext.hidden = content.scrollLeft >= maxScroll - 4;
      }

      if (isCarousel) {
        var scrollTicking = false;
        content.addEventListener(
          'scroll',
          function () {
            if (scrollTicking) return;
            scrollTicking = true;
            window.requestAnimationFrame(function () {
              scrollTicking = false;
              updateCarouselControls();
            });
          },
          { passive: true }
        );
        window.addEventListener('resize', updateCarouselControls);
      }

      if (contentPrev) {
        contentPrev.addEventListener('click', function () {
          if (isCarousel) {
            content.scrollBy({ left: -slideStep(), behavior: 'smooth' });
            return;
          }
          if (activeColumnIndex <= 0) return;
          activeColumnIndex -= 1;
          showActiveColumn();
        });
      }

      if (contentNext) {
        contentNext.addEventListener('click', function () {
          if (isCarousel) {
            content.scrollBy({ left: slideStep(), behavior: 'smooth' });
            return;
          }
          if (activeColumnIndex >= activeColumns.length - 1) return;
          activeColumnIndex += 1;
          showActiveColumn();
        });
      }

      activate(tabKeys[0]);

      /* Once the page is idle, warm up the images of the non-active tabs so
         switching tabs and swiping never waits on lazy loading. */
      var idle = window.requestIdleCallback
        ? window.requestIdleCallback.bind(window)
        : function (cb) { setTimeout(cb, 1500); };
      idle(function () {
        eagerLoadImages(Array.prototype.slice.call(cols));
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
